/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData, getCurrentTimeByType } from '../../util/index'
import { message } from 'antd'
import { GETCLUBEXPENDLIST, GETPERIOD } from './constants'

export const getClubExpendList = (payload) => {
  return {
    type: GETCLUBEXPENDLIST,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}

//支出明细
export function fetchClubExpendList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/CashExpenditureOut`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubExpendList(data))
      return data
    })
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    dispatch(getPeriod(getCurrentTimeByType(type)))
  }
}

//搜索
export function fetchSearchExpend(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/CashExpenditureOut`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubExpendList(data))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubExpend/action.js